import { ReactComponent as RapIcon } from 'assets/effects/rap.svg';
import { ReactComponent as AutotuneIcon } from 'assets/effects/autotune.svg';
import { ReactComponent as EchoIcon } from 'assets/effects/echo.svg';
import { ReactComponent as GraveIcon } from 'assets/effects/grave.svg';
import { ReactComponent as ChorusIcon } from 'assets/effects/heart.svg';
import { ReactComponent as RobotIcon } from 'assets/effects/robot.svg';
import { ReactComponent as ChipmunkIcon } from 'assets/effects/chipmunk.svg';

export const vocalPresets = {
  DEFAULT: [
    [0xb4, 0x1, 0x0],
    [0xb4, 0x2, 0x22],
    [0xb4, 0x3, 0x12],
    [0xb4, 0x4, 0x0],
    [0xb4, 0x5, 0x77],
    [0xb4, 0x6, 0x12],
    [0xb4, 0x7, 0x0],
    [0xb4, 0x8, 0x22],
    [0xb4, 0x9, 0x12],
    [0xb4, 0xa, 0x0],
    [0xb4, 0xb, 0x52],
    [0xb4, 0xc, 0x12],
    [0xb2, 0x1, 0x7f],
    [0xb2, 0x2, 0x0],
    [0xb2, 0x3, 0x7f],
    [0xb2, 0x4, 0x7f],
    [0xb2, 0x5, 0x7f],
    [0xb2, 0x6, 0x7f],
    [0xb2, 0x7, 0x7f],
    [0xb2, 0x8, 0x7f],
    [0xb2, 0x9, 0x7f],
    [0xb2, 0xa, 0x7f],
    [0xb2, 0xb, 0x7f],
    [0xb2, 0xc, 0x7f],
    [0xb2, 0xd, 0x7f],
    [0xb2, 0xe, 0x7f],
    [0xb2, 0xf, 0x0],
    [0xb2, 0x10, 0x7f],
    [0xb2, 0x11, 0x7f],
    [0xb2, 0x12, 0x7f],
    [0xb2, 0x13, 0x0],
    [0xb2, 0x14, 0x0],
    [0xb2, 0x15, 0x0],
    [0xb2, 0x16, 0x0],
    [0xb2, 0x17, 0x40],
    [0xb2, 0x18, 0x40],
    [0xb2, 0x19, 0x0],
    [0xb3, 0x1, 0x7f],
    [0xb3, 0x2, 0x0],
    [0xb3, 0x3, 0x7f],
    [0xb3, 0x4, 0x7f],
    [0xb3, 0x5, 0x7f],
    [0xb3, 0x6, 0x7f],
    [0xb3, 0x7, 0x7f],
    [0xb3, 0x8, 0x7f],
    [0xb3, 0x9, 0x7f],
    [0xb3, 0xa, 0x7f],
    [0xb3, 0xb, 0x7f],
    [0xb3, 0xc, 0x7f],
    [0xb3, 0xd, 0x7f],
    [0xb3, 0xe, 0x7f],
    [0xb3, 0xf, 0x0],
    [0xb3, 0x10, 0x7f],
    [0xb3, 0x11, 0x7f],
    [0xb3, 0x12, 0x7f],
    [0xb3, 0x13, 0x0],
    [0xb3, 0x14, 0x0],
    [0xb3, 0x15, 0x0],
    [0xb3, 0x16, 0x0],
    [0xb3, 0x17, 0x40],
    [0xb3, 0x18, 0x40],
    [0xb3, 0x19, 0x0],
    [0xb0, 0x11, 0x0],
    [0xb0, 0x12, 0x22],
    [0xb0, 0x13, 0x12],
    [0xb0, 0x14, 0x40],
    [0xb0, 0x15, 0x0],
    [0xb0, 0x16, 0x29],
    [0xb0, 0x17, 0x12],
    [0xb0, 0x18, 0x40],
    [0xb0, 0x19, 0x0],
    [0xb0, 0x1a, 0x35],
    [0xb0, 0x1b, 0x12],
    [0xb0, 0x1c, 0x40],
    [0xb0, 0x1d, 0x0],
    [0xb0, 0x1e, 0x40],
    [0xb0, 0x1f, 0x12],
    [0xb0, 0xf, 0x40],
    [0xb0, 0x31, 0x0],
    [0xb0, 0x32, 0x22],
    [0xb0, 0x33, 0x12],
    [0xb0, 0x34, 0x40],
    [0xb0, 0x35, 0x0],
    [0xb0, 0x36, 0x29],
    [0xb0, 0x37, 0x12],
    [0xb0, 0x38, 0x40],
    [0xb0, 0x39, 0x0],
    [0xb0, 0x3a, 0x35],
    [0xb0, 0x3b, 0x12],
    [0xb0, 0x3c, 0x40],
    [0xb0, 0x3d, 0x0],
    [0xb0, 0x3e, 0x40],
    [0xb0, 0x3f, 0x12],
    [0xb0, 0x40, 0x40],
    [0xb0, 0x65, 0x0],
    [0xb0, 0x66, 0x0],
    [0xb0, 0x67, 0x0],
    [0xb0, 0x68, 0x6a],
    [0xb0, 0x69, 0x6a],
    [0xb0, 0x6a, 0x6a],
    [0xb0, 0x6b, 0x0],
    [0xb0, 0x6c, 0x0],
    [0xb0, 0x6d, 0x0],
    [0xb0, 0x6e, 0x6a],
    [0xb0, 0x6f, 0x6a],
    [0xb0, 0x70, 0x6a],
    [0xb1, 0x1, 0x7f],
    [0xb1, 0x2, 0x6c],
    [0xb1, 0x3, 0x0],
    [0xb1, 0x4, 0x0],
    [0xb1, 0x5, 0x0],
    [0xb1, 0x6, 0x7f],
    [0xb1, 0x7, 0x0],
    [0xb1, 0x8, 0x7f],
    [0xb1, 0x9, 0x6c],
    [0xb1, 0xa, 0x0],
    [0xb1, 0xb, 0x0],
    [0xb1, 0xc, 0x0],
    [0xb1, 0xd, 0x7f],
    [0xb1, 0xe, 0x0],
    [0xb0, 0x51, 0x0],
    [0xb0, 0x52, 0x40],
    [0xb0, 0x53, 0x7f],
    [0xb0, 0x54, 0x60],
    [0xb0, 0x55, 0x0],
    [0xb0, 0x56, 0x66],
    [0xb0, 0x57, 0x0],
    [0xb0, 0x58, 0x0],
    [0xb0, 0x59, 0x6a],
    [0xb0, 0x5a, 0x0],
    [0xb0, 0x5b, 0x40],
    [0xb0, 0x5c, 0x7f],
    [0xb0, 0x5d, 0x60],
    [0xb0, 0x5e, 0x0],
    [0xb0, 0x5f, 0x66],
    [0xb0, 0x60, 0x0],
    [0xb0, 0x61, 0x0],
    [0xb0, 0x62, 0x6a],
  ],
  RAP: [
    [0xb4, 0x1, 0x17],
    [0xb4, 0x2, 0x25],
    [0xb4, 0x3, 0x1e],
    [0xb4, 0x4, 0x2e],
    [0xb4, 0x5, 0x77],
    [0xb4, 0x6, 0x0],
    [0xb4, 0x7, 0x0],
    [0xb4, 0x8, 0x22],
    [0xb4, 0x9, 0x12],
    [0xb4, 0xa, 0x0],
    [0xb4, 0xb, 0x52],
    [0xb4, 0xc, 0x12],
    [0xb2, 0x1, 0x0],
    [0xb2, 0x2, 0x7f],
    [0xb2, 0x3, 0x7f],
    [0xb2, 0x4, 0x7f],
    [0xb2, 0x5, 0x7f],
    [0xb2, 0x6, 0x7f],
    [0xb2, 0x7, 0x7f],
    [0xb2, 0x8, 0x7f],
    [0xb2, 0x9, 0x7f],
    [0xb2, 0xa, 0x7f],
    [0xb2, 0xb, 0x7f],
    [0xb2, 0xc, 0x7f],
    [0xb2, 0xd, 0x7f],
    [0xb2, 0xe, 0x7f],
    [0xb2, 0xf, 0x0],
    [0xb2, 0x10, 0x0],
    [0xb2, 0x11, 0x7f],
    [0xb2, 0x12, 0x7f],
    [0xb2, 0x13, 0x0],
    [0xb2, 0x14, 0x0],
    [0xb2, 0x15, 0x0],
    [0xb2, 0x16, 0x0],
    [0xb2, 0x17, 0x40],
    [0xb2, 0x18, 0x35],
    [0xb2, 0x19, 0x0],
    [0xb3, 0x1, 0x7f],
    [0xb3, 0x2, 0x0],
    [0xb3, 0x3, 0x7f],
    [0xb3, 0x4, 0x7f],
    [0xb3, 0x5, 0x7f],
    [0xb3, 0x6, 0x7f],
    [0xb3, 0x7, 0x7f],
    [0xb3, 0x8, 0x7f],
    [0xb3, 0x9, 0x7f],
    [0xb3, 0xa, 0x7f],
    [0xb3, 0xb, 0x7f],
    [0xb3, 0xc, 0x7f],
    [0xb3, 0xd, 0x7f],
    [0xb3, 0xe, 0x7f],
    [0xb3, 0xf, 0x0],
    [0xb3, 0x10, 0x7f],
    [0xb3, 0x11, 0x7f],
    [0xb3, 0x12, 0x7f],
    [0xb3, 0x13, 0x0],
    [0xb3, 0x14, 0x0],
    [0xb3, 0x15, 0x0],
    [0xb3, 0x16, 0x0],
    [0xb3, 0x17, 0x40],
    [0xb3, 0x18, 0x40],
    [0xb3, 0x19, 0x0],
    [0xb0, 0x11, 0xc],
    [0xb0, 0x12, 0x2f],
    [0xb0, 0x13, 0x40],
    [0xb0, 0x14, 0x40],
    [0xb0, 0x15, 0xc],
    [0xb0, 0x16, 0x34],
    [0xb0, 0x17, 0x72],
    [0xb0, 0x18, 0x39],
    [0xb0, 0x19, 0xc],
    [0xb0, 0x1a, 0x5f],
    [0xb0, 0x1b, 0x12],
    [0xb0, 0x1c, 0x39],
    [0xb0, 0x1d, 0xc],
    [0xb0, 0x1e, 0x71],
    [0xb0, 0x1f, 0x12],
    [0xb0, 0xf, 0x44],
    [0xb0, 0x31, 0x0],
    [0xb0, 0x32, 0x22],
    [0xb0, 0x33, 0x12],
    [0xb0, 0x34, 0x40],
    [0xb0, 0x35, 0x0],
    [0xb0, 0x36, 0x29],
    [0xb0, 0x37, 0x12],
    [0xb0, 0x38, 0x40],
    [0xb0, 0x39, 0x0],
    [0xb0, 0x3a, 0x35],
    [0xb0, 0x3b, 0x12],
    [0xb0, 0x3c, 0x40],
    [0xb0, 0x3d, 0x0],
    [0xb0, 0x3e, 0x40],
    [0xb0, 0x3f, 0x12],
    [0xb0, 0x40, 0x40],
    [0xb0, 0x65, 0x0],
    [0xb0, 0x66, 0x0],
    [0xb0, 0x67, 0x0],
    [0xb0, 0x68, 0x6a],
    [0xb0, 0x69, 0x6a],
    [0xb0, 0x6a, 0x6a],
    [0xb0, 0x6b, 0x0],
    [0xb0, 0x6c, 0x0],
    [0xb0, 0x6d, 0x0],
    [0xb0, 0x6e, 0x6a],
    [0xb0, 0x6f, 0x6a],
    [0xb0, 0x70, 0x6a],
    [0xb1, 0x1, 0x0],
    [0xb1, 0x2, 0x40],
    [0xb1, 0x3, 0x0],
    [0xb1, 0x4, 0x0],
    [0xb1, 0x5, 0x39],
    [0xb1, 0x6, 0x7f],
    [0xb1, 0x7, 0x1c],
    [0xb1, 0x8, 0x7f],
    [0xb1, 0x9, 0x6c],
    [0xb1, 0xa, 0x0],
    [0xb1, 0xb, 0x0],
    [0xb1, 0xc, 0x0],
    [0xb1, 0xd, 0x7f],
    [0xb1, 0xe, 0x0],
    [0xb0, 0x51, 0x27],
    [0xb0, 0x52, 0x40],
    [0xb0, 0x53, 0x59],
    [0xb0, 0x54, 0x51],
    [0xb0, 0x55, 0x0],
    [0xb0, 0x56, 0x66],
    [0xb0, 0x57, 0x0],
    [0xb0, 0x58, 0x0],
    [0xb0, 0x59, 0x6a],
    [0xb0, 0x5a, 0x0],
    [0xb0, 0x5b, 0x40],
    [0xb0, 0x5c, 0x7f],
    [0xb0, 0x5d, 0x60],
    [0xb0, 0x5e, 0x0],
    [0xb0, 0x5f, 0x66],
    [0xb0, 0x60, 0x0],
    [0xb0, 0x61, 0x0],
    [0xb0, 0x62, 0x6a],
  ],
  AUTOTUNE: [
    [0xb4, 0x1, 0x2e],
    [0xb4, 0x2, 0x78],
    [0xb4, 0x3, 0x6],
    [0xb4, 0x4, 0x17],
    [0xb4, 0x5, 0x26],
    [0xb4, 0x6, 0x12],
    [0xb4, 0x7, 0x0],
    [0xb4, 0x8, 0x22],
    [0xb4, 0x9, 0x12],
    [0xb4, 0xa, 0x0],
    [0xb4, 0xb, 0x52],
    [0xb4, 0xc, 0x12],
    [0xb2, 0x1, 0x0],
    [0xb2, 0x2, 0x7f],
    [0xb2, 0x3, 0x7f],
    [0xb2, 0x4, 0x7f],
    [0xb2, 0x5, 0x7f],
    [0xb2, 0x6, 0x7f],
    [0xb2, 0x7, 0x7f],
    [0xb2, 0x8, 0x7f],
    [0xb2, 0x9, 0x7f],
    [0xb2, 0xa, 0x7f],
    [0xb2, 0xb, 0x7f],
    [0xb2, 0xc, 0x7f],
    [0xb2, 0xd, 0x7f],
    [0xb2, 0xe, 0x7f],
    [0xb2, 0xf, 0x1e],
    [0xb2, 0x10, 0x5d],
    [0xb2, 0x11, 0x7f],
    [0xb2, 0x12, 0x7f],
    [0xb2, 0x13, 0x0],
    [0xb2, 0x14, 0x0],
    [0xb2, 0x15, 0x0],
    [0xb2, 0x16, 0x0],
    [0xb2, 0x17, 0x40],
    [0xb2, 0x18, 0x40],
    [0xb2, 0x19, 0x0],
    [0xb3, 0x1, 0x7f],
    [0xb3, 0x2, 0x0],
    [0xb3, 0x3, 0x7f],
    [0xb3, 0x4, 0x7f],
    [0xb3, 0x5, 0x7f],
    [0xb3, 0x6, 0x7f],
    [0xb3, 0x7, 0x7f],
    [0xb3, 0x8, 0x7f],
    [0xb3, 0x9, 0x7f],
    [0xb3, 0xa, 0x7f],
    [0xb3, 0xb, 0x7f],
    [0xb3, 0xc, 0x7f],
    [0xb3, 0xd, 0x7f],
    [0xb3, 0xe, 0x7f],
    [0xb3, 0xf, 0x0],
    [0xb3, 0x10, 0x7f],
    [0xb3, 0x11, 0x7f],
    [0xb3, 0x12, 0x7f],
    [0xb3, 0x13, 0x0],
    [0xb3, 0x14, 0x0],
    [0xb3, 0x15, 0x0],
    [0xb3, 0x16, 0x0],
    [0xb3, 0x17, 0x40],
    [0xb3, 0x18, 0x40],
    [0xb3, 0x19, 0x0],
    [0xb0, 0x11, 0xc],
    [0xb0, 0x12, 0x33],
    [0xb0, 0x13, 0x26],
    [0xb0, 0x14, 0x3b],
    [0xb0, 0x15, 0xc],
    [0xb0, 0x16, 0x55],
    [0xb0, 0x17, 0x26],
    [0xb0, 0x18, 0x3c],
    [0xb0, 0x19, 0xc],
    [0xb0, 0x1a, 0x5f],
    [0xb0, 0x1b, 0x26],
    [0xb0, 0x1c, 0x46],
    [0xb0, 0x1d, 0xc],
    [0xb0, 0x1e, 0x71],
    [0xb0, 0x1f, 0x13],
    [0xb0, 0xf, 0x47],
    [0xb0, 0x31, 0x0],
    [0xb0, 0x32, 0x29],
    [0xb0, 0x33, 0x13],
    [0xb0, 0x34, 0x47],
    [0xb0, 0x35, 0x0],
    [0xb0, 0x36, 0x29],
    [0xb0, 0x37, 0x12],
    [0xb0, 0x38, 0x40],
    [0xb0, 0x39, 0x0],
    [0xb0, 0x3a, 0x35],
    [0xb0, 0x3b, 0x12],
    [0xb0, 0x3c, 0x40],
    [0xb0, 0x3d, 0x0],
    [0xb0, 0x3e, 0x40],
    [0xb0, 0x3f, 0x12],
    [0xb0, 0x40, 0x40],
    [0xb0, 0x65, 0x0],
    [0xb0, 0x66, 0x0],
    [0xb0, 0x67, 0x0],
    [0xb0, 0x68, 0x6a],
    [0xb0, 0x69, 0x6a],
    [0xb0, 0x6a, 0x6a],
    [0xb0, 0x6b, 0x0],
    [0xb0, 0x6c, 0x0],
    [0xb0, 0x6d, 0x0],
    [0xb0, 0x6e, 0x6a],
    [0xb0, 0x6f, 0x6a],
    [0xb0, 0x70, 0x6a],
    [0xb1, 0x1, 0x7f],
    [0xb1, 0x2, 0x6c],
    [0xb1, 0x3, 0x0],
    [0xb1, 0x4, 0x0],
    [0xb1, 0x5, 0x0],
    [0xb1, 0x6, 0x7f],
    [0xb1, 0x7, 0x0],
    [0xb1, 0x8, 0x7f],
    [0xb1, 0x9, 0x6c],
    [0xb1, 0xa, 0x0],
    [0xb1, 0xb, 0x0],
    [0xb1, 0xc, 0x0],
    [0xb1, 0xd, 0x7f],
    [0xb1, 0xe, 0x0],
    [0xb0, 0x51, 0x1f],
    [0xb0, 0x52, 0x40],
    [0xb0, 0x53, 0x7f],
    [0xb0, 0x54, 0x5c],
    [0xb0, 0x55, 0x72],
    [0xb0, 0x56, 0x5e],
    [0xb0, 0x57, 0x0],
    [0xb0, 0x58, 0x0],
    [0xb0, 0x59, 0x6a],
    [0xb0, 0x5a, 0x0],
    [0xb0, 0x5b, 0x40],
    [0xb0, 0x5c, 0x7f],
    [0xb0, 0x5d, 0x60],
    [0xb0, 0x5e, 0x0],
    [0xb0, 0x5f, 0x66],
    [0xb0, 0x60, 0x0],
    [0xb0, 0x61, 0x0],
    [0xb0, 0x62, 0x6a],
  ],
  CHIPMUNK: [
    [0xb4, 0x1, 0x2e],
    [0xb4, 0x2, 0x78],
    [0xb4, 0x3, 0x6],
    [0xb4, 0x4, 0x17],
    [0xb4, 0x5, 0x26],
    [0xb4, 0x6, 0x12],
    [0xb4, 0x7, 0x0],
    [0xb4, 0x8, 0x22],
    [0xb4, 0x9, 0x12],
    [0xb4, 0xa, 0x0],
    [0xb4, 0xb, 0x52],
    [0xb4, 0xc, 0x12],
    [0xb2, 0x1, 0x0],
    [0xb2, 0x2, 0x0],
    [0xb2, 0x3, 0x7f],
    [0xb2, 0x4, 0x7f],
    [0xb2, 0x5, 0x7f],
    [0xb2, 0x6, 0x7f],
    [0xb2, 0x7, 0x7f],
    [0xb2, 0x8, 0x7f],
    [0xb2, 0x9, 0x7f],
    [0xb2, 0xa, 0x7f],
    [0xb2, 0xb, 0x7f],
    [0xb2, 0xc, 0x7f],
    [0xb2, 0xd, 0x7f],
    [0xb2, 0xe, 0x7f],
    [0xb2, 0xf, 0x0],
    [0xb2, 0x10, 0x7f],
    [0xb2, 0x11, 0x7f],
    [0xb2, 0x12, 0x7f],
    [0xb2, 0x13, 0x0],
    [0xb2, 0x14, 0x0],
    [0xb2, 0x15, 0x0],
    [0xb2, 0x16, 0x0],
    [0xb2, 0x17, 0x40],
    [0xb2, 0x18, 0x7f],
    [0xb2, 0x19, 0x20],
    [0xb3, 0x1, 0x7f],
    [0xb3, 0x2, 0x0],
    [0xb3, 0x3, 0x7f],
    [0xb3, 0x4, 0x7f],
    [0xb3, 0x5, 0x7f],
    [0xb3, 0x6, 0x7f],
    [0xb3, 0x7, 0x7f],
    [0xb3, 0x8, 0x7f],
    [0xb3, 0x9, 0x7f],
    [0xb3, 0xa, 0x7f],
    [0xb3, 0xb, 0x7f],
    [0xb3, 0xc, 0x7f],
    [0xb3, 0xd, 0x7f],
    [0xb3, 0xe, 0x7f],
    [0xb3, 0xf, 0x0],
    [0xb3, 0x10, 0x7f],
    [0xb3, 0x11, 0x7f],
    [0xb3, 0x12, 0x7f],
    [0xb3, 0x13, 0x0],
    [0xb3, 0x14, 0x0],
    [0xb3, 0x15, 0x0],
    [0xb3, 0x16, 0x0],
    [0xb3, 0x17, 0x40],
    [0xb3, 0x18, 0x40],
    [0xb3, 0x19, 0x0],
    [0xb0, 0x11, 0xc],
    [0xb0, 0x12, 0x33],
    [0xb0, 0x13, 0x26],
    [0xb0, 0x14, 0x3b],
    [0xb0, 0x15, 0xc],
    [0xb0, 0x16, 0x55],
    [0xb0, 0x17, 0x26],
    [0xb0, 0x18, 0x3c],
    [0xb0, 0x19, 0xc],
    [0xb0, 0x1a, 0x5f],
    [0xb0, 0x1b, 0x26],
    [0xb0, 0x1c, 0x46],
    [0xb0, 0x1d, 0xc],
    [0xb0, 0x1e, 0x71],
    [0xb0, 0x1f, 0x13],
    [0xb0, 0xf, 0x47],
    [0xb0, 0x31, 0x0],
    [0xb0, 0x32, 0x29],
    [0xb0, 0x33, 0x13],
    [0xb0, 0x34, 0x47],
    [0xb0, 0x35, 0x0],
    [0xb0, 0x36, 0x29],
    [0xb0, 0x37, 0x12],
    [0xb0, 0x38, 0x40],
    [0xb0, 0x39, 0x0],
    [0xb0, 0x3a, 0x35],
    [0xb0, 0x3b, 0x12],
    [0xb0, 0x3c, 0x40],
    [0xb0, 0x3d, 0x0],
    [0xb0, 0x3e, 0x40],
    [0xb0, 0x3f, 0x12],
    [0xb0, 0x40, 0x40],
    [0xb0, 0x65, 0x0],
    [0xb0, 0x66, 0x20],
    [0xb0, 0x67, 0x4a],
    [0xb0, 0x68, 0x6a],
    [0xb0, 0x69, 0x6c],
    [0xb0, 0x6a, 0x6c],
    [0xb0, 0x6b, 0x0],
    [0xb0, 0x6c, 0x0],
    [0xb0, 0x6d, 0x0],
    [0xb0, 0x6e, 0x6a],
    [0xb0, 0x6f, 0x6a],
    [0xb0, 0x70, 0x6a],
    [0xb1, 0x1, 0x0],
    [0xb1, 0x2, 0x2b],
    [0xb1, 0x3, 0x33],
    [0xb1, 0x4, 0x0],
    [0xb1, 0x5, 0x7f],
    [0xb1, 0x6, 0x7f],
    [0xb1, 0x7, 0x2b],
    [0xb1, 0x8, 0x7f],
    [0xb1, 0x9, 0x6c],
    [0xb1, 0xa, 0x0],
    [0xb1, 0xb, 0x0],
    [0xb1, 0xc, 0x0],
    [0xb1, 0xd, 0x7f],
    [0xb1, 0xe, 0x0],
    [0xb0, 0x51, 0x1f],
    [0xb0, 0x52, 0x40],
    [0xb0, 0x53, 0x7f],
    [0xb0, 0x54, 0x5c],
    [0xb0, 0x55, 0x72],
    [0xb0, 0x56, 0x5e],
    [0xb0, 0x57, 0x0],
    [0xb0, 0x58, 0x0],
    [0xb0, 0x59, 0x6a],
    [0xb0, 0x5a, 0x0],
    [0xb0, 0x5b, 0x40],
    [0xb0, 0x5c, 0x7f],
    [0xb0, 0x5d, 0x60],
    [0xb0, 0x5e, 0x0],
    [0xb0, 0x5f, 0x66],
    [0xb0, 0x60, 0x0],
    [0xb0, 0x61, 0x0],
    [0xb0, 0x62, 0x6a],
  ],
  CHORUS: [
    [0xb4, 0x1, 0x2e],
    [0xb4, 0x2, 0x78],
    [0xb4, 0x3, 0x6],
    [0xb4, 0x4, 0x17],
    [0xb4, 0x5, 0x26],
    [0xb4, 0x6, 0x12],
    [0xb4, 0x7, 0x0],
    [0xb4, 0x8, 0x22],
    [0xb4, 0x9, 0x12],
    [0xb4, 0xa, 0x0],
    [0xb4, 0xb, 0x52],
    [0xb4, 0xc, 0x12],
    [0xb2, 0x1, 0x0],
    [0xb2, 0x2, 0x37],
    [0xb2, 0x3, 0x7f],
    [0xb2, 0x4, 0x7f],
    [0xb2, 0x5, 0x7f],
    [0xb2, 0x6, 0x7f],
    [0xb2, 0x7, 0x7f],
    [0xb2, 0x8, 0x7f],
    [0xb2, 0x9, 0x7f],
    [0xb2, 0xa, 0x7f],
    [0xb2, 0xb, 0x7f],
    [0xb2, 0xc, 0x7f],
    [0xb2, 0xd, 0x7f],
    [0xb2, 0xe, 0x7f],
    [0xb2, 0xf, 0x51],
    [0xb2, 0x10, 0x7f],
    [0xb2, 0x11, 0x7f],
    [0xb2, 0x12, 0x0],
    [0xb2, 0x13, 0x1a],
    [0xb2, 0x14, 0x0],
    [0xb2, 0x15, 0x2b],
    [0xb2, 0x16, 0x0],
    [0xb2, 0x17, 0x40],
    [0xb2, 0x18, 0x40],
    [0xb2, 0x19, 0x7f],
    [0xb3, 0x1, 0x7f],
    [0xb3, 0x2, 0x0],
    [0xb3, 0x3, 0x7f],
    [0xb3, 0x4, 0x7f],
    [0xb3, 0x5, 0x7f],
    [0xb3, 0x6, 0x7f],
    [0xb3, 0x7, 0x7f],
    [0xb3, 0x8, 0x7f],
    [0xb3, 0x9, 0x7f],
    [0xb3, 0xa, 0x7f],
    [0xb3, 0xb, 0x7f],
    [0xb3, 0xc, 0x7f],
    [0xb3, 0xd, 0x7f],
    [0xb3, 0xe, 0x7f],
    [0xb3, 0xf, 0x0],
    [0xb3, 0x10, 0x7f],
    [0xb3, 0x11, 0x7f],
    [0xb3, 0x12, 0x7f],
    [0xb3, 0x13, 0x0],
    [0xb3, 0x14, 0x0],
    [0xb3, 0x15, 0x0],
    [0xb3, 0x16, 0x0],
    [0xb3, 0x17, 0x40],
    [0xb3, 0x18, 0x40],
    [0xb3, 0x19, 0x0],
    [0xb0, 0x11, 0xc],
    [0xb0, 0x12, 0x33],
    [0xb0, 0x13, 0x26],
    [0xb0, 0x14, 0x3b],
    [0xb0, 0x15, 0xc],
    [0xb0, 0x16, 0x55],
    [0xb0, 0x17, 0x26],
    [0xb0, 0x18, 0x3c],
    [0xb0, 0x19, 0xc],
    [0xb0, 0x1a, 0x5f],
    [0xb0, 0x1b, 0x26],
    [0xb0, 0x1c, 0x46],
    [0xb0, 0x1d, 0xc],
    [0xb0, 0x1e, 0x71],
    [0xb0, 0x1f, 0x13],
    [0xb0, 0xf, 0x47],
    [0xb0, 0x31, 0x0],
    [0xb0, 0x32, 0x29],
    [0xb0, 0x33, 0x13],
    [0xb0, 0x34, 0x47],
    [0xb0, 0x35, 0x0],
    [0xb0, 0x36, 0x29],
    [0xb0, 0x37, 0x12],
    [0xb0, 0x38, 0x40],
    [0xb0, 0x39, 0x0],
    [0xb0, 0x3a, 0x35],
    [0xb0, 0x3b, 0x12],
    [0xb0, 0x3c, 0x40],
    [0xb0, 0x3d, 0x0],
    [0xb0, 0x3e, 0x40],
    [0xb0, 0x3f, 0x12],
    [0xb0, 0x40, 0x40],
    [0xb0, 0x65, 0x0],
    [0xb0, 0x66, 0x20],
    [0xb0, 0x67, 0x4a],
    [0xb0, 0x68, 0x6a],
    [0xb0, 0x69, 0x6c],
    [0xb0, 0x6a, 0x6c],
    [0xb0, 0x6b, 0x0],
    [0xb0, 0x6c, 0x0],
    [0xb0, 0x6d, 0x0],
    [0xb0, 0x6e, 0x6a],
    [0xb0, 0x6f, 0x6a],
    [0xb0, 0x70, 0x6a],
    [0xb1, 0x1, 0x0],
    [0xb1, 0x2, 0x40],
    [0xb1, 0x3, 0x33],
    [0xb1, 0x4, 0x13],
    [0xb1, 0x5, 0x0],
    [0xb1, 0x6, 0x7f],
    [0xb1, 0x7, 0x40],
    [0xb1, 0x8, 0x7f],
    [0xb1, 0x9, 0x6c],
    [0xb1, 0xa, 0x0],
    [0xb1, 0xb, 0x0],
    [0xb1, 0xc, 0x0],
    [0xb1, 0xd, 0x7f],
    [0xb1, 0xe, 0x0],
    [0xb0, 0x51, 0x1f],
    [0xb0, 0x52, 0x40],
    [0xb0, 0x53, 0x7f],
    [0xb0, 0x54, 0x5c],
    [0xb0, 0x55, 0x72],
    [0xb0, 0x56, 0x5e],
    [0xb0, 0x57, 0x0],
    [0xb0, 0x58, 0x0],
    [0xb0, 0x59, 0x6a],
    [0xb0, 0x5a, 0x0],
    [0xb0, 0x5b, 0x40],
    [0xb0, 0x5c, 0x7f],
    [0xb0, 0x5d, 0x60],
    [0xb0, 0x5e, 0x0],
    [0xb0, 0x5f, 0x66],
    [0xb0, 0x60, 0x0],
    [0xb0, 0x61, 0x0],
    [0xb0, 0x62, 0x6a],
  ],
  GRAVE: [
    [0xb4, 0x1, 0x2e],
    [0xb4, 0x2, 0x78],
    [0xb4, 0x3, 0x6],
    [0xb4, 0x4, 0x17],
    [0xb4, 0x5, 0x28],
    [0xb4, 0x6, 0x12],
    [0xb4, 0x7, 0x0],
    [0xb4, 0x8, 0x22],
    [0xb4, 0x9, 0x12],
    [0xb4, 0xa, 0x0],
    [0xb4, 0xb, 0x52],
    [0xb4, 0xc, 0x12],
    [0xb2, 0x1, 0x0],
    [0xb2, 0x2, 0x0],
    [0xb2, 0x3, 0x7f],
    [0xb2, 0x4, 0x7f],
    [0xb2, 0x5, 0x7f],
    [0xb2, 0x6, 0x7f],
    [0xb2, 0x7, 0x7f],
    [0xb2, 0x8, 0x7f],
    [0xb2, 0x9, 0x7f],
    [0xb2, 0xa, 0x7f],
    [0xb2, 0xb, 0x7f],
    [0xb2, 0xc, 0x7f],
    [0xb2, 0xd, 0x7f],
    [0xb2, 0xe, 0x7f],
    [0xb2, 0xf, 0x0],
    [0xb2, 0x10, 0x7f],
    [0xb2, 0x11, 0x7f],
    [0xb2, 0x12, 0x0],
    [0xb2, 0x13, 0x0],
    [0xb2, 0x14, 0x0],
    [0xb2, 0x15, 0x0],
    [0xb2, 0x16, 0x0],
    [0xb2, 0x17, 0x40],
    [0xb2, 0x18, 0x0],
    [0xb2, 0x19, 0x26],
    [0xb3, 0x1, 0x7f],
    [0xb3, 0x2, 0x0],
    [0xb3, 0x3, 0x7f],
    [0xb3, 0x4, 0x7f],
    [0xb3, 0x5, 0x7f],
    [0xb3, 0x6, 0x7f],
    [0xb3, 0x7, 0x7f],
    [0xb3, 0x8, 0x7f],
    [0xb3, 0x9, 0x7f],
    [0xb3, 0xa, 0x7f],
    [0xb3, 0xb, 0x7f],
    [0xb3, 0xc, 0x7f],
    [0xb3, 0xd, 0x7f],
    [0xb3, 0xe, 0x7f],
    [0xb3, 0xf, 0x0],
    [0xb3, 0x10, 0x7f],
    [0xb3, 0x11, 0x7f],
    [0xb3, 0x12, 0x7f],
    [0xb3, 0x13, 0x0],
    [0xb3, 0x14, 0x0],
    [0xb3, 0x15, 0x0],
    [0xb3, 0x16, 0x0],
    [0xb3, 0x17, 0x40],
    [0xb3, 0x18, 0x40],
    [0xb3, 0x19, 0x0],
    [0xb0, 0x11, 0xc],
    [0xb0, 0x12, 0x2a],
    [0xb0, 0x13, 0x2c],
    [0xb0, 0x14, 0x40],
    [0xb0, 0x15, 0xc],
    [0xb0, 0x16, 0x55],
    [0xb0, 0x17, 0x26],
    [0xb0, 0x18, 0x3c],
    [0xb0, 0x19, 0x3a],
    [0xb0, 0x1a, 0x27],
    [0xb0, 0x1b, 0x20],
    [0xb0, 0x1c, 0x40],
    [0xb0, 0x1d, 0xc],
    [0xb0, 0x1e, 0x71],
    [0xb0, 0x1f, 0x13],
    [0xb0, 0xf, 0x43],
    [0xb0, 0x31, 0x0],
    [0xb0, 0x32, 0x29],
    [0xb0, 0x33, 0x13],
    [0xb0, 0x34, 0x47],
    [0xb0, 0x35, 0x0],
    [0xb0, 0x36, 0x29],
    [0xb0, 0x37, 0x12],
    [0xb0, 0x38, 0x40],
    [0xb0, 0x39, 0x0],
    [0xb0, 0x3a, 0x35],
    [0xb0, 0x3b, 0x12],
    [0xb0, 0x3c, 0x40],
    [0xb0, 0x3d, 0x0],
    [0xb0, 0x3e, 0x40],
    [0xb0, 0x3f, 0x12],
    [0xb0, 0x40, 0x40],
    [0xb0, 0x65, 0x0],
    [0xb0, 0x66, 0x20],
    [0xb0, 0x67, 0x4a],
    [0xb0, 0x68, 0x6a],
    [0xb0, 0x69, 0x6c],
    [0xb0, 0x6a, 0x6c],
    [0xb0, 0x6b, 0x0],
    [0xb0, 0x6c, 0x0],
    [0xb0, 0x6d, 0x0],
    [0xb0, 0x6e, 0x6a],
    [0xb0, 0x6f, 0x6a],
    [0xb0, 0x70, 0x6a],
    [0xb1, 0x1, 0x0],
    [0xb1, 0x2, 0x3c],
    [0xb1, 0x3, 0x58],
    [0xb1, 0x4, 0x0],
    [0xb1, 0x5, 0x6d],
    [0xb1, 0x6, 0x7f],
    [0xb1, 0x7, 0x30],
    [0xb1, 0x8, 0x7f],
    [0xb1, 0x9, 0x6c],
    [0xb1, 0xa, 0x0],
    [0xb1, 0xb, 0x0],
    [0xb1, 0xc, 0x0],
    [0xb1, 0xd, 0x7f],
    [0xb1, 0xe, 0x0],
    [0xb0, 0x51, 0x1f],
    [0xb0, 0x52, 0x40],
    [0xb0, 0x53, 0x7f],
    [0xb0, 0x54, 0x5c],
    [0xb0, 0x55, 0x72],
    [0xb0, 0x56, 0x5e],
    [0xb0, 0x57, 0x0],
    [0xb0, 0x58, 0x0],
    [0xb0, 0x59, 0x6a],
    [0xb0, 0x5a, 0x0],
    [0xb0, 0x5b, 0x40],
    [0xb0, 0x5c, 0x7f],
    [0xb0, 0x5d, 0x60],
    [0xb0, 0x5e, 0x0],
    [0xb0, 0x5f, 0x66],
    [0xb0, 0x60, 0x0],
    [0xb0, 0x61, 0x0],
    [0xb0, 0x62, 0x6a],
  ],
  ROBOT: [
    [0xb4, 0x1, 0x2e],
    [0xb4, 0x2, 0x78],
    [0xb4, 0x3, 0x6],
    [0xb4, 0x4, 0x17],
    [0xb4, 0x5, 0x26],
    [0xb4, 0x6, 0x12],
    [0xb4, 0x7, 0x0],
    [0xb4, 0x8, 0x22],
    [0xb4, 0x9, 0x12],
    [0xb4, 0xa, 0x0],
    [0xb4, 0xb, 0x52],
    [0xb4, 0xc, 0x12],
    [0xb2, 0x1, 0x0],
    [0xb2, 0x2, 0x0],
    [0xb2, 0x3, 0x0],
    [0xb2, 0x4, 0x0],
    [0xb2, 0x5, 0x0],
    [0xb2, 0x6, 0x0],
    [0xb2, 0x7, 0x0],
    [0xb2, 0x8, 0x0],
    [0xb2, 0x9, 0x0],
    [0xb2, 0xa, 0x0],
    [0xb2, 0xb, 0x0],
    [0xb2, 0xc, 0x0],
    [0xb2, 0xd, 0x0],
    [0xb2, 0xe, 0x0],
    [0xb2, 0xf, 0x0],
    [0xb2, 0x10, 0x7f],
    [0xb2, 0x11, 0x7f],
    [0xb2, 0x12, 0x7f],
    [0xb2, 0x13, 0x0],
    [0xb2, 0x14, 0x0],
    [0xb2, 0x15, 0x7f],
    [0xb2, 0x16, 0x0],
    [0xb2, 0x17, 0x40],
    [0xb2, 0x18, 0x40],
    [0xb2, 0x19, 0x0],
    [0xb3, 0x1, 0x7f],
    [0xb3, 0x2, 0x0],
    [0xb3, 0x3, 0x7f],
    [0xb3, 0x4, 0x7f],
    [0xb3, 0x5, 0x7f],
    [0xb3, 0x6, 0x7f],
    [0xb3, 0x7, 0x7f],
    [0xb3, 0x8, 0x7f],
    [0xb3, 0x9, 0x7f],
    [0xb3, 0xa, 0x7f],
    [0xb3, 0xb, 0x7f],
    [0xb3, 0xc, 0x7f],
    [0xb3, 0xd, 0x7f],
    [0xb3, 0xe, 0x7f],
    [0xb3, 0xf, 0x0],
    [0xb3, 0x10, 0x7f],
    [0xb3, 0x11, 0x7f],
    [0xb3, 0x12, 0x7f],
    [0xb3, 0x13, 0x0],
    [0xb3, 0x14, 0x0],
    [0xb3, 0x15, 0x0],
    [0xb3, 0x16, 0x0],
    [0xb3, 0x17, 0x40],
    [0xb3, 0x18, 0x40],
    [0xb3, 0x19, 0x0],
    [0xb0, 0x11, 0xc],
    [0xb0, 0x12, 0x33],
    [0xb0, 0x13, 0x26],
    [0xb0, 0x14, 0x3b],
    [0xb0, 0x15, 0xc],
    [0xb0, 0x16, 0x55],
    [0xb0, 0x17, 0x26],
    [0xb0, 0x18, 0x3c],
    [0xb0, 0x19, 0xc],
    [0xb0, 0x1a, 0x5f],
    [0xb0, 0x1b, 0x26],
    [0xb0, 0x1c, 0x46],
    [0xb0, 0x1d, 0xc],
    [0xb0, 0x1e, 0x49],
    [0xb0, 0x1f, 0x13],
    [0xb0, 0xf, 0x2e],
    [0xb0, 0x31, 0x0],
    [0xb0, 0x32, 0x29],
    [0xb0, 0x33, 0x13],
    [0xb0, 0x34, 0x47],
    [0xb0, 0x35, 0x0],
    [0xb0, 0x36, 0x29],
    [0xb0, 0x37, 0x12],
    [0xb0, 0x38, 0x40],
    [0xb0, 0x39, 0x0],
    [0xb0, 0x3a, 0x35],
    [0xb0, 0x3b, 0x12],
    [0xb0, 0x3c, 0x40],
    [0xb0, 0x3d, 0x0],
    [0xb0, 0x3e, 0x40],
    [0xb0, 0x3f, 0x12],
    [0xb0, 0x40, 0x40],
    [0xb0, 0x65, 0x0],
    [0xb0, 0x66, 0x0],
    [0xb0, 0x67, 0x0],
    [0xb0, 0x68, 0x6a],
    [0xb0, 0x69, 0x6a],
    [0xb0, 0x6a, 0x6a],
    [0xb0, 0x6b, 0x0],
    [0xb0, 0x6c, 0x0],
    [0xb0, 0x6d, 0x0],
    [0xb0, 0x6e, 0x6a],
    [0xb0, 0x6f, 0x6a],
    [0xb0, 0x70, 0x6a],
    [0xb1, 0x1, 0x7f],
    [0xb1, 0x2, 0x6c],
    [0xb1, 0x3, 0x0],
    [0xb1, 0x4, 0x0],
    [0xb1, 0x5, 0x0],
    [0xb1, 0x6, 0x7f],
    [0xb1, 0x7, 0x0],
    [0xb1, 0x8, 0x7f],
    [0xb1, 0x9, 0x6c],
    [0xb1, 0xa, 0x0],
    [0xb1, 0xb, 0x0],
    [0xb1, 0xc, 0x0],
    [0xb1, 0xd, 0x7f],
    [0xb1, 0xe, 0x0],
    [0xb0, 0x51, 0x1f],
    [0xb0, 0x52, 0x40],
    [0xb0, 0x53, 0x7f],
    [0xb0, 0x54, 0x5c],
    [0xb0, 0x55, 0x72],
    [0xb0, 0x56, 0x5e],
    [0xb0, 0x57, 0x0],
    [0xb0, 0x58, 0x0],
    [0xb0, 0x59, 0x6a],
    [0xb0, 0x5a, 0x0],
    [0xb0, 0x5b, 0x40],
    [0xb0, 0x5c, 0x7f],
    [0xb0, 0x5d, 0x60],
    [0xb0, 0x5e, 0x0],
    [0xb0, 0x5f, 0x66],
    [0xb0, 0x60, 0x0],
    [0xb0, 0x61, 0x0],
    [0xb0, 0x62, 0x6a],
  ],
  ECHO: [
    [0xb4, 0x1, 0x2e],
    [0xb4, 0x2, 0x78],
    [0xb4, 0x3, 0x6],
    [0xb4, 0x4, 0x17],
    [0xb4, 0x5, 0x26],
    [0xb4, 0x6, 0x12],
    [0xb4, 0x7, 0x0],
    [0xb4, 0x8, 0x22],
    [0xb4, 0x9, 0x12],
    [0xb4, 0xa, 0x0],
    [0xb4, 0xb, 0x52],
    [0xb4, 0xc, 0x12],
    [0xb2, 0x1, 0x7f],
    [0xb2, 0x2, 0x0],
    [0xb2, 0x3, 0x7f],
    [0xb2, 0x4, 0x7f],
    [0xb2, 0x5, 0x7f],
    [0xb2, 0x6, 0x7f],
    [0xb2, 0x7, 0x7f],
    [0xb2, 0x8, 0x7f],
    [0xb2, 0x9, 0x7f],
    [0xb2, 0xa, 0x7f],
    [0xb2, 0xb, 0x7f],
    [0xb2, 0xc, 0x7f],
    [0xb2, 0xd, 0x7f],
    [0xb2, 0xe, 0x7f],
    [0xb2, 0xf, 0x51],
    [0xb2, 0x10, 0x7f],
    [0xb2, 0x11, 0x7f],
    [0xb2, 0x12, 0x7f],
    [0xb2, 0x13, 0x0],
    [0xb2, 0x14, 0x0],
    [0xb2, 0x15, 0x0],
    [0xb2, 0x16, 0x0],
    [0xb2, 0x17, 0x40],
    [0xb2, 0x18, 0x40],
    [0xb2, 0x19, 0x0],
    [0xb3, 0x1, 0x7f],
    [0xb3, 0x2, 0x0],
    [0xb3, 0x3, 0x7f],
    [0xb3, 0x4, 0x7f],
    [0xb3, 0x5, 0x7f],
    [0xb3, 0x6, 0x7f],
    [0xb3, 0x7, 0x7f],
    [0xb3, 0x8, 0x7f],
    [0xb3, 0x9, 0x7f],
    [0xb3, 0xa, 0x7f],
    [0xb3, 0xb, 0x7f],
    [0xb3, 0xc, 0x7f],
    [0xb3, 0xd, 0x7f],
    [0xb3, 0xe, 0x7f],
    [0xb3, 0xf, 0x0],
    [0xb3, 0x10, 0x7f],
    [0xb3, 0x11, 0x7f],
    [0xb3, 0x12, 0x7f],
    [0xb3, 0x13, 0x0],
    [0xb3, 0x14, 0x0],
    [0xb3, 0x15, 0x0],
    [0xb3, 0x16, 0x0],
    [0xb3, 0x17, 0x40],
    [0xb3, 0x18, 0x40],
    [0xb3, 0x19, 0x0],
    [0xb0, 0x11, 0xc],
    [0xb0, 0x12, 0x33],
    [0xb0, 0x13, 0x26],
    [0xb0, 0x14, 0x3b],
    [0xb0, 0x15, 0xc],
    [0xb0, 0x16, 0x55],
    [0xb0, 0x17, 0x26],
    [0xb0, 0x18, 0x3c],
    [0xb0, 0x19, 0xc],
    [0xb0, 0x1a, 0x5d],
    [0xb0, 0x1b, 0x26],
    [0xb0, 0x1c, 0x39],
    [0xb0, 0x1d, 0xc],
    [0xb0, 0x1e, 0x49],
    [0xb0, 0x1f, 0x13],
    [0xb0, 0xf, 0x2b],
    [0xb0, 0x31, 0x0],
    [0xb0, 0x32, 0x29],
    [0xb0, 0x33, 0x13],
    [0xb0, 0x34, 0x47],
    [0xb0, 0x35, 0x0],
    [0xb0, 0x36, 0x29],
    [0xb0, 0x37, 0x12],
    [0xb0, 0x38, 0x40],
    [0xb0, 0x39, 0x0],
    [0xb0, 0x3a, 0x35],
    [0xb0, 0x3b, 0x12],
    [0xb0, 0x3c, 0x40],
    [0xb0, 0x3d, 0x0],
    [0xb0, 0x3e, 0x40],
    [0xb0, 0x3f, 0x12],
    [0xb0, 0x40, 0x40],
    [0xb0, 0x65, 0x2a],
    [0xb0, 0x66, 0xf],
    [0xb0, 0x67, 0x7a],
    [0xb0, 0x68, 0x6a],
    [0xb0, 0x69, 0x64],
    [0xb0, 0x6a, 0x64],
    [0xb0, 0x6b, 0x0],
    [0xb0, 0x6c, 0x0],
    [0xb0, 0x6d, 0x0],
    [0xb0, 0x6e, 0x6a],
    [0xb0, 0x6f, 0x6a],
    [0xb0, 0x70, 0x6a],
    [0xb1, 0x1, 0x0],
    [0xb1, 0x2, 0x46],
    [0xb1, 0x3, 0x38],
    [0xb1, 0x4, 0x3],
    [0xb1, 0x5, 0x29],
    [0xb1, 0x6, 0x7f],
    [0xb1, 0x7, 0x29],
    [0xb1, 0x8, 0x7f],
    [0xb1, 0x9, 0x6c],
    [0xb1, 0xa, 0x0],
    [0xb1, 0xb, 0x0],
    [0xb1, 0xc, 0x0],
    [0xb1, 0xd, 0x7f],
    [0xb1, 0xe, 0x0],
    [0xb0, 0x51, 0x1f],
    [0xb0, 0x52, 0x40],
    [0xb0, 0x53, 0x7f],
    [0xb0, 0x54, 0x5c],
    [0xb0, 0x55, 0x72],
    [0xb0, 0x56, 0x5e],
    [0xb0, 0x57, 0x0],
    [0xb0, 0x58, 0x0],
    [0xb0, 0x59, 0x6a],
    [0xb0, 0x5a, 0x0],
    [0xb0, 0x5b, 0x40],
    [0xb0, 0x5c, 0x7f],
    [0xb0, 0x5d, 0x60],
    [0xb0, 0x5e, 0x0],
    [0xb0, 0x5f, 0x66],
    [0xb0, 0x60, 0x0],
    [0xb0, 0x61, 0x0],
    [0xb0, 0x62, 0x6a],
  ],
};

export enum VocalEffects {
  DEFAULT = 'DEFAULT',
  RAP = 'RAP',
  CHIPMUNK = 'CHIPMUNK',
  GRAVE = 'GRAVE',
  CHORUS = 'CHORUS',
  ROBOT = 'ROBOT',
  AUTOTUNE = 'AUTOTUNE',
  ECHO = 'ECHO',
}

export const VocalEffectsList = [
  {
    name: VocalEffects.DEFAULT,
    color: '#000000',
    translationId: '',
  },
  {
    name: VocalEffects.RAP,
    color: '#E85BAF',
    icon: RapIcon,
    translationId: 'voice-effects.effects.rap',
  },
  {
    name: VocalEffects.CHIPMUNK,
    color: '#FF7300',
    icon: ChipmunkIcon,
    translationId: 'voice-effects.effects.chipmunk',
  },
  {
    name: VocalEffects.GRAVE,
    color: '#61FF59',
    icon: GraveIcon,
    translationId: 'voice-effects.effects.bass',
  },
  {
    name: VocalEffects.CHORUS,
    color: '#FF87A0',
    icon: ChorusIcon,
    translationId: 'voice-effects.effects.choir',
  },
  {
    name: VocalEffects.ROBOT,
    color: '#61BDFF',
    icon: RobotIcon,
    translationId: 'voice-effects.effects.robot',
  },
  {
    name: VocalEffects.AUTOTUNE,
    color: '#E6C6FF',
    icon: AutotuneIcon,
    translationId: 'voice-effects.effects.autotune',
  },
  {
    name: VocalEffects.ECHO,
    color: '#FFC04B',
    icon: EchoIcon,
    translationId: 'voice-effects.effects.echo',
  },
];

interface MusicPitch {
  [key: string]: number;
}

export const MUSIC_PITCH: MusicPitch = {
  '-4': 0x2a,
  '-3': 0x2f,
  '-2': 0x34,
  '-1': 0x3a,
  '0': 0x3f,
  '1': 0x44,
  '2': 0x4a,
  '3': 0x4f,
  '4': 0x5a,
};
